<main class="main">
  <mat-dialog-content>
    <h2 class="main--text">{{ 'requestAppraisal' | i18next }}</h2>
  </mat-dialog-content>
  <mat-dialog-content>
    <h5 class="main--text">{{ 'textAppraisal' | i18next }}</h5>
  </mat-dialog-content>
  <form [formGroup]="form" class="main--form">
    <mat-form-field>
      <mat-label>{{ 'appraisalExpectedDate' | i18next }}</mat-label>
      <input
        matInput
        [matDatepicker]="picker"
        formControlName="expectedDate"
        [min]="minDate"
        readonly
      />
      <mat-datepicker-toggle
        matIconSuffix
        [for]="picker"
      ></mat-datepicker-toggle>
      <mat-datepicker #picker (closed)="close()"></mat-datepicker>
    </mat-form-field>
    <mat-form-field>
      <mat-label>{{ 'appraisalExpectedKm' | i18next }}</mat-label>
      <input matInput formControlName="appraisalExpectedKm" type="number" />
    </mat-form-field>
  </form>
  <mat-dialog-actions>
    <button type="button" class="btn cancel btn-cancel" mat-dialog-close>
      {{ 'altCancel' | i18next | uppercase }}
    </button>
    <button
      type="submit"
      class="btn confirmDark"
      (click)="submitRequest()"
      [disabled]="form.invalid"
    >
      {{ 'stepConfirm' | i18next | uppercase }}
    </button>
  </mat-dialog-actions>
</main>
